import 'slick-carousel'
import $ from 'jquery'

$(document).ready(function () {
  $('.news-slider__carousel').each(function (i, el) {
    if (!$(el).hasClass('slick-initialized')) {
      $(el).slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      })
    }
  })
})
